export enum PLAY_PICKERS {
    /**
     * @value Filter by title or description
     * @description Placeholder for video search
     */
    SEARCH_PLACEHOLDER = 'PLAY.VIDEO_LIBRARY_SEARCH_PLACEHOLDER',
    /**
     * @value Select playlist
     * @description Title of the playlist picker dialog
     */
    SELECT_PLAYLIST = 'PLAY.SELECT_PLAYLIST',
}
